module.exports = __webpack_public_path__ + "img/960.751f0c91.svg";